/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProductionSpeedType {
    HSP = 'hsp',
    STANDARD = 'standard',
}
